import React, { useEffect, useState } from "react";
import { Sidebar } from "../components/Note";
import UserMenu from "../components/UserMenu";
import api from "../api";
import { useNavigate } from "react-router-dom";

export default function AgenteIA() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { data } = await api.get("user/features/");
        const flags = Array.isArray(data?.features) ? data.features : [];
        if (mounted) {
          setEnabled(flags.includes("ai_agent"));
        }
      } catch (_) {
        if (mounted) setEnabled(false);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="flex">
        <Sidebar />
        <main className="flex-1 p-6">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100">Agente de IA</h1>
            <UserMenu />
          </div>

          {loading ? (
            <div className="text-gray-600 dark:text-gray-300">Cargando…</div>
          ) : !enabled ? (
            <div className="bg-yellow-50 border border-yellow-200 text-yellow-800 rounded-lg p-4">
              No tienes acceso a esta funcionalidad. Si crees que es un error, contacta a soporte.
            </div>
          ) : (
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow p-6">
              <p className="text-gray-700 dark:text-gray-200">
                Aquí irá el módulo del Agente de IA. Por ahora es un placeholder protegido por feature flag "ai_agent".
              </p>
            </div>
          )}
        </main>
      </div>
    </div>
  );
}
